import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import OutlinedButton from "../../../components/button/OutlinedButton";
import H1 from "../../../components/typography/H1";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  z-index: 1;
  opacity: 1;
  transition: opacity 0.4s ease-in-out;
`;

const Wrapper = styled.div`
  width: 100%;
  height: inherit;
  position: relative;
  cursor: pointer;
  &:hover {
    ${Overlay} {
      opacity: 0.6;
    }
    button {
      background-color: ${colors.backgroundPrimary};
      transition-duration: 0.6s;
      color: ${colors.textPrimary};
    }
  }
`;

const Container = styled.div`
  position: relative;
  width: inherit;

  img {
    width: inherit;
    max-height: 700px;
    min-height: 250px;
    height: auto;
    object-fit: cover;
    display: block;
  }
`;

const Info = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 2;
  @media (max-width: 600px) {
    h1 {
      font-size: ${fontSize.s};
    }
  }
`;

function CategoryHeroSmall({ categoryName, imageUrl }) {
  const navigate = useNavigate();
  return (
    <Wrapper
      onClick={() => {
        navigate(`/products/${categoryName.toLowerCase()}`);
      }}
    >
      <Container>
        <img src={imageUrl} alt={categoryName} />
        <Overlay />
        <Info style={{ color: colors.backgroundPrimary }}>
          <H1> {categoryName} by Wallet</H1>
          <OutlinedButton text={"SEE MORE"} style={{ width: "140px" }} />
        </Info>
      </Container>
    </Wrapper>
  );
}

export default CategoryHeroSmall;
